import { drawDefinitionConstants, eventConstants } from 'tods-competition-factory';
import { isFunction } from 'functions/typeOf';

const { SINGLES } = eventConstants;
const { MAIN, QUALIFYING, VOLUNTARY_CONSOLATION } = drawDefinitionConstants;

const STAGE_LABELS: Record<string, string> = {
  [QUALIFYING]: 'Q',
  [VOLUNTARY_CONSOLATION]: 'VC',
};

export const flightsFormatter =
  (onClick: (params: any) => void) =>
  (cell: any): HTMLDivElement => {
    const def = cell.getColumn().getDefinition();
    const content = document.createElement('div');
    content.className = 'tags';

    const flightClick = (params: any) => onClick({ ...params, renderDraw: true });

    const flights = cell.getValue();
    const rowData = cell.getRow().getData();
    const { participantId } = rowData;
    flights?.forEach((flight: any) => {
      const pill = createPill({ def, participantId, flight, flightClick });
      content.appendChild(pill);
    });

    return content;
  };

function createPill({
  flight,
  flightClick,
}: {
  flight: any;
  flightClick: (params: any) => void;
  def?: any;
  participantId?: string;
}): HTMLSpanElement {
  const pill = document.createElement('span');
  if (isFunction(flightClick) && flightClick) {
    pill.onclick = () => flightClick(flight);
  }
  pill.className = 'tag event-pill';
  if (flight.gender?.toLowerCase().includes('female')) {
    pill.classList.add('is-danger');
  } else if (flight.gender?.toLowerCase().includes('male')) {
    pill.classList.add('is-link');
  } else {
    pill.classList.add('is-primary');
  }
  if (flight.eventType === SINGLES) {
    pill.classList.add('is-light');
  }

  const stageLabel = flight.entryStage && flight.entryStage !== MAIN ? STAGE_LABELS[flight.entryStage] : undefined;
  if (stageLabel) {
    const badge = document.createElement('span');
    badge.style.cssText =
      'display:inline-flex;align-items:center;justify-content:center;width:18px;height:18px;border-radius:50%;font-size:9px;font-weight:700;background:rgba(0,0,0,0.15);margin-right:4px;flex-shrink:0';
    badge.textContent = stageLabel;
    pill.appendChild(badge);
    const nameSpan = document.createElement('span');
    nameSpan.textContent = flight.drawName;
    pill.appendChild(nameSpan);
  } else {
    pill.textContent = flight.drawName;
  }

  return pill;
}
